import { render, staticRenderFns } from "./GoalWrapper.vue?vue&type=template&id=8b49a758&"
import script from "./GoalWrapper.vue?vue&type=script&lang=ts&"
export * from "./GoalWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports